import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedOrganisationApiService } from './organisation-api-generated.service';
import { Observable } from 'rxjs';
import { Organisation } from '@get/api-interfaces';

@Injectable({
  providedIn: 'root'
})
export class OrganisationApiService extends GeneratedOrganisationApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }

  public getUserOrganisation(params: { idUser: number; params?: any }): Observable<Organisation> {
    return this.repo.getData<Organisation>('organisation/getUserOrganisation/' + params.idUser, params.params);
  }
}
